/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./face.vue.js?vue&type=template&id=23853561&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./face.vue?vue&type=template&id=23853561&scoped=true"
import script from "./face.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./face.vue?vue&type=script&setup=true&lang=js"
export * from "./face.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./face.vue?vue&type=script&setup=true&lang=js"
import style0 from "./face.vue.css?vue&type=style&index=0&id=23853561&prod&lang=css!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./face.vue?vue&type=style&index=0&id=23853561&prod&lang=css"
import style1 from "./face.vue.postcss?vue&type=style&index=1&id=23853561&prod&lang=postcss&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./face.vue?vue&type=style&index=1&id=23853561&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23853561",
  null
  
)

export default component.exports